export default function ENFP(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “پیکارگر”</h1>{" "}
          <blockquote>
            <p>
              برایم مهم نیست برای گذران زندگی چه کاری انجام می&zwnj;دهید.
              می&zwnj;خواهم بدانم چه چیزی را با تمام وجود می&zwnj;خواهید - و آیا
              جرأت آن را دارید که رؤیای برآورده کردن اشتیاق قلبی خود را در سر
              بپرورانید. برایم مهم نیست چند ساله هستید. می&zwnj;خواهم بدانم آیا
              این خطر را می&zwnj;پذیرید که مثل یک احمق به نظر برسید - برای
              عشقتان - برای رؤیاهایتان - برای ماجراجویی زنده بودن.
            </p>{" "}
            <footer>Oriah Mountain Dreamer</footer>
          </blockquote>{" "}
          <p>
            شخصیت پیکارگر یک روح به&zwnj;راستی آزاد است. آن&zwnj;ها اغلب به
            مهمانی&zwnj;ها جان می&zwnj;بخشند، اما کمتر به هیجان محض و لذت بردن
            از لحظه علاقه&zwnj;مند هستند تا بهره&zwnj;گیری از ارتباطات اجتماعی و
            عاطفی که با دیگران دارند. این افراد جذاب، مستقل، پرانرژی و دلسوز را
            که 7% درصد جمعیت را تشکیل می&zwnj;دهند مطمئناً می&zwnj;توان در هر
            جمعیتی شناخت.
          </p>{" "}
          <h2>می&zwnj;توانید جهان را با فقط یک ایده تغییر دهید</h2>{" "}
          <p>
            پیکارگران تنها افرادی خوش مشرب نیستند که به دنبال خشنود کردن مردم
            باشند، بلکه ماهیت رؤیاپردازشان آنها را شکل داده و به آنها اجازه
            می&zwnj;دهد با کنجکاوی و انرژی به دنبال ناگفته&zwnj;ها باشند.
            آن&zwnj;ها معمولاً زندگی را مثل یک پازل بزرگ و پیچیده می&zwnj;بینند
            که در آن همه چیز با هم مرتبط است، اما پیکارگران - بر خلاف شخصیت های
            گروه نقش تحلیلگر که معمولاً چنین پازلی را مجموعه&zwnj;ای از
            سازوکارهای نظام&zwnj;مند تلقی می&zwnj;کنند - آن را از طریق منشوری از
            احساسات، شفقت و رمز و راز می&zwnj;بینند و همیشه به دنبال معنایی
            عمیق&zwnj;تر هستند.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              پیکارگران شدیداً مستقل هستند و بسیار بیشتر از ثبات و امنیت در پی
              خلاقیت و آزادی هستند.
            </p>
          </blockquote>{" "}
          <p>
            بسیاری از گونه &zwnj;های شخصیتی دیگر به احتمال زیاد قادر به مقاومت
            در برای چنین ویژگی&zwnj;هایی نیستند، و اگر پیکارگران علتی برای روشن
            کردن چراغ تخیل خود بیابند، آنقدر انرژی صرف آن می&zwnj;کنند که اغلب
            در کانون توجه قرار می&zwnj;گیرند و همتایانشان آنها را
            به&zwnj;&lrm;عنوان رهبر و مربی برمی&zwnj;گزینند - اما پیکارگران
            استقلال&zwnj;دوست نمی&zwnj;خواهند همیشه در چنین موقعیت&zwnj;هایی
            قرار بگیرند. بدتر از آن وقتی است که این شخصیت&zwnj;ها ببینند درگیر
            کارهای اداری و رویه&zwnj;های معمول شده&zwnj;اند که ممکن است با
            جایگاه رهبری همراه باشد. عزت نفس پیکارگران به توانایی آنها برای
            دستیابی به راه حل&zwnj;های اصیل وابسته است، و آنها باید بدانند که
            این آزادی را دارند که دست به نوآوری بزنند - اگر در نقشی
            خسته&zwnj;کننده گیر بیفتند ممکن است به&zwnj;سرعت صبر خود را از دست
            بدهند یا افسرده شوند.
          </p>{" "}
          <h2>آن "جرقه کوچک جنون" را از دست مده</h2>{" "}
          <p>
            خوشبختانه افراد گونه شخصیتی پیکارگر می&zwnj;دانند چگونه به آرامش
            برسند و کاملاً قادر به تبدیل کردن خود از آرمانگرایی پرشور در محل کار
            به روحی آزاد و خیال&zwnj;پرداز و مشتاق در هنگام رقص هستند، و این امر
            اغلب چنان به&zwnj;طور ناگهانی رخ می&zwnj;دهد که حتی می&zwnj;تواند
            نزدیکترین دوستانشان را متعجب کند. بودن در جمع به آنها فرصت برقراری
            روابط عاطفی با دیگران را نیز می&zwnj;دهد و باعث می&zwnj;شود انگیزه
            دوستان و همکاران خود را درک کنند. آن&zwnj;ها بر این باورند که هر کس
            باید زمان صرف کند تا احساسات خود را بشناسد و ابراز نماید و همدلی و
            اجتماعی بودن آنها باعث می&zwnj;شود به&zwnj;طور طبیعی این مسئله به
            موضوع گفتگویشان تبدیل شود.
          </p>{" "}
          <p>
            با این حال افراد دارای شخصیت پیکارگر باید مراقب باشند - اگر بیش از
            حد به شهود خود تکیه کنند یا انگیزه دوستان خود را مفروض بگیرند یا
            پیش&zwnj;بینی کنند، ممکن است نشانه&zwnj;های دریافتی را به اشتباه
            تعبیر کنند و باعث نابودی برنامه&zwnj;هایی شوند که با روشی
            سرراست&zwnj;تر به&zwnj;راحتی قابل انجام بود. این نوع استرس اجتماعی
            هراسی است که باعث می&zwnj;شود این سنخ شخصیتی که بر هماهنگی متمرکز
            شبها خوابش نبرد. پیکارگران بسیار عاطفی و حساس هستند و وقتی باعث رنجش
            شخص دیگری می&zwnj;شوند، هر دویشان آن را احساس می&zwnj;کنند.
          </p>{" "}
          <p>
            پیکارگران قبل از پیدا کردن چیزی که واقعاً برایشان درست به نظر برسد،
            زمان زیادی را صرف کنکاش در روابط اجتماعی، احساسات و ایده&zwnj;ها
            می&zwnj;کنند. اما زمانی که این شخصیت&zwnj;ها سرانجام جایگاه خود را
            در جهان پیدا کردند، تخیل، همدلی و شجاعتشان به احتمال فراوان نتایجی
            باورنکردنی پدید خواهد آورد.
          </p>
        </article>
      </div>
    </div>
  );
}
